import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { renderRoutes } from 'react-router-config'

import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'

import { Button, Flex } from 'antd'
import { Col, Layout, Row } from 'antd-v3/es'

import { userReloadPage$ } from 'src/store/modules/user'

import {
  APPLE_APP_ADRESS,
  GOOGLE_APP_ADRESS,
  LANDING_ADRESS,
  YEAR_FORMAT
} from 'src/constants'

const AuthLayout = ({
  showLoginButton,
  history,
  route = {},
  userReloadPage = false
}) => {
  useEffect(() => {
    if (!userReloadPage) return

    window.location.reload()
  }, [userReloadPage])

  return (
    <Layout className="auth-layout">
      <Layout.Header className="auth-layout__header">
        <Flex align="flex-start">
          {showLoginButton && (
            <Button
              style={{ position: 'absolute' }}
              onClick={() => history.push('/auth/login')}
              type="primary">
              <Flex gap={10} align="center">
                <FontAwesomeIcon size="xl" icon={faAngleLeft} />
                <span>Login page</span>
              </Flex>
            </Button>
          )}

          <a className="logo_header" href={LANDING_ADRESS} />
        </Flex>
      </Layout.Header>

      <Row
        className="auth-layout-row"
        type="flex"
        justify="space-around"
        align="middle">
        <Col className="auth-col" xs={24}>
          {renderRoutes(route.routes)}
        </Col>
      </Row>

      <Layout.Footer className="auth-layout__footer">
        <div className="footer__box">
          <div className="footer__aside">
            <a className="logo_footer" href={LANDING_ADRESS} />

            <span>© {moment().format(YEAR_FORMAT)} Emmacare</span>
          </div>

          <div className="footer__apps">
            <a className="app-link app-link_apple" href={APPLE_APP_ADRESS} />

            <a className="app-link app-link_google" href={GOOGLE_APP_ADRESS} />
          </div>

          <div className="footer__nav">
            <a href={LANDING_ADRESS} title="Who we serve">
              Who we serve
            </a>
            <a href={`${LANDING_ADRESS}/solution`} title="Our solution">
              Our solution
            </a>
            <a href={`${LANDING_ADRESS}/about`} title="About">
              About
            </a>
            <a href={`${LANDING_ADRESS}/contact`} title="Contact us">
              Contact us
            </a>
          </div>
        </div>
      </Layout.Footer>
    </Layout>
  )
}

const AuthLayoutWrapper = ({ route }) => {
  const location = useLocation()

  const showLoginButton = location.pathname.startsWith('/auth/two-factor-auth')

  const selectors = {
    showLoginButton,
    history: useHistory(),
    userReloadPage: useSelector(userReloadPage$)
  }

  return <AuthLayout {...selectors} route={route} />
}

export default AuthLayoutWrapper
